import React from 'react'
import _ from 'lodash'
import SectionFormPopup from './SectionFormPopup'
import CourseFormPopup from './CourseFormPopup'
import AddNewCard from '../../components/AddNewCard'
import SectionCard from '../../components/SectionCard'
import {OnboardingTeacherContext} from '../../contexts/OnboardingTeacherContextProvider'
import {convertStudentStartTrack, handleTaskComplete, status, step_id} from '../../components/OnboardingHomepage/onboardingUtils'
import '../../assets/css/pages/class_management/roster-list.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit } from '@fortawesome/free-solid-svg-icons'
library.add(faEdit)

class RosterList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedCourse: {},
      showNewSectionForm: false
    }
  }
  getDefaultCourseValues = ()=>{
    const course = this.state.selectedCourse
    return {
      id:   course.id,
      name: course.name
    }
  }

  handleSubmit = vals => {
    const onSuccess = ()=>this.setState({ selectedCourse: {} })
    this.props.handleUpdateCourse(vals, onSuccess)
  }

  //onboarding check - is there a class?
  static contextType = OnboardingTeacherContext
  onboardingUpdate_hasCreatedClass = (rosters) =>{
    if(!this.context.isAllComplete && this.context.studentStartTrack.steps.createClass !== _.indexOf(status,'completed') && !_.isEmpty(rosters)){
      const updateOnboardingCred = {
        stepId: _.indexOf(step_id,'hasCreatedClass')
      }
      const updateOnboardingTaskComplete = {
        onComplete: json => {
          const errors = json.data.completeOnboardingStep.errors
          if(!_.isEmpty(errors)){
            errors.map(error => console.error(error))
          }
          else{
            const data = json.data.completeOnboardingStep.updatedContext
            const studentTrackUpdate = convertStudentStartTrack(data)
            this.context.setStudentStartTrack(prev => ({
              ...prev,
              completedSteps: this.context.studentStartTrack.completedSteps + 1,
              ...studentTrackUpdate
            }))
            this.context.setIsAllComplete(data.allOnboardingStepsCompleted)
            this.context.setCurrentPath('teacher_studentStartPath')
          }
        },
        onFailure: error => {
          console.error(error)
        }
      }
      handleTaskComplete(updateOnboardingTaskComplete,updateOnboardingCred)
    }
  }

  render() {
    const { rosters, course, onSubmit, handleUpdateCourse, handleSubmitNewSection, isCreatingSection, createSectionErrors, isUpdatingCourse, updateCourseErrors } = this.props
    const courseCollection = _.map(this.props.rosters, c =>({ value: c.id, label: c.name }))
    this.onboardingUpdate_hasCreatedClass(rosters)
    return(
      <div className='roster-list'>
        {_.map(rosters, course=>
          <div className='course-group' key={course.id}>
            <h2 className='course-name'>
              {course.name}
              <span className='course-edit' onClick={()=>this.setState({ selectedCourse: course })}><FontAwesomeIcon icon='edit'/></span>
            </h2>
            {course.description && <p>{course.description}</p>}
            <br/>
            <div className='row'>
              {_.isEmpty(course.sections) &&
                <h3>No classes are registered for this course.</h3>
              }
              {_.map(course.sections, section=>
                <SectionCard key={section.id} courseId={section.course_id} section={section}/>
              )}
            </div>
          </div>
        )}
        <div className='manage-group'>
          <h2>Manage</h2>
          <br/>
          <div className='row'>
            <AddNewCard onClick={()=>this.setState({ showNewSectionForm: true })} titleText='New Class' labelContents={<i className='fa fa-plus'></i>} subtitleText='Create a New Class' />
          </div>
        </div>

        {/* Popups */}
        {!_.isEmpty(this.state.selectedCourse) &&
          <CourseFormPopup
            course={this.state.selectedCourse}
            onClose={()=>this.setState({ selectedCourse: {} })}
            defaultValues={this.getDefaultCourseValues()}
            isSubmitting={isUpdatingCourse}
            errors={updateCourseErrors}
            handleSubmit={this.handleSubmit}
          />
        }
        {this.state.showNewSectionForm  &&
          <SectionFormPopup
            onClose={()=>this.setState({ showNewSectionForm: false })}
            onSubmit={handleSubmitNewSection}
            courseCollection={courseCollection}
            isSubmitting={isCreatingSection}
            errors={createSectionErrors}
          />
        }
      </div>
    )
  }
}

export default RosterList
